(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('UniversityListController', UniversityListController);

    /** @ngInject */
    function UniversityListController($scope, $state, $stateParams, $rootScope, UniversityService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        let videosPerPage;
        let videosSkip;
        let forcePaginationReset;
        let isTableSearch;

        vm.getVideoImage = video => {
            return HelperService.imageResizePath('videos', video.Id, video.Image, 500, 300);
        }

        vm.isSearchDisabled = () => {
            if (vm.datePicker.date.startDate || vm.searchText || vm.selectedCategory)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.datePicker.date.startDate || vm.searchText || vm.selectedCategory)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.getPaginatedVideo({
                    page: vm.currentPage
                });
            }
        }

        vm.clearSearch = () => {
            vm.datePicker.date.startDate = moment();
            vm.datePicker.date.endDate = moment().add(1, 'days');
            vm.searchText = '';
            vm.selectedCategory = null;

            if (isTableSearch) {
                vm.getPaginatedVideo({
                    page: vm.currentPage
                });

                isTableSearch = false;
            }
        }

        vm.getPaginatedVideo = pageData => {
            if (vm.isLoading)
                return;

            if (forcePaginationReset) {
                vm.currentPage = 1;
                forcePaginationReset = false;
            } else
                vm.currentPage = pageData.page;

            videosSkip = (vm.currentPage - 1) * videosPerPage;

            getVideos();
        }

        vm.onChangeCategory = () => {
            if (vm.selectedCategory) {
                let currentCategory = vm.categories.find(x => (x.Url == $stateParams.universityCategory));
                let currentPage = $stateParams.universityPage;

                $state.go('app-master.default.university', {
                    universityPage: currentPage,
                    universityCategory: vm.selectedCategory.Url
                });

                if (currentCategory.Id != vm.selectedCategory.Id)
                    currentPage = 1;

                vm.getPaginatedVideo({
                    page: currentPage
                })
            }
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getVideos() {
            HelperService.startLoading('.university-holder');

            vm.videos = [];
            vm.isLoading = true;

            const parameters = prepareParameters();
            let userData = AuthenticationService.getUserData();

            parameters.ResponsibilityId = userData.Responsibility.Id;

            UniversityService
                .getAllByParameters(parameters, userData.Id)
                .then(success => {
                    vm.videos = success.Videos;
                    vm.numberOfPages = success.NumberOfPages;
                    vm.isLoading = false;

                    $state.go('app-master.default.university', {
                        universityPage: vm.currentPage
                    });

                    HelperService.stopLoading('.university-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters() {
            let params = {
                PerPage: videosPerPage,
                Skip: videosSkip,
                OrderBy: 'StartDate',
                OrderDescending: false,
                Active: true
            }

            if (vm.selectedCategory) {
                params.CategoryId = vm.selectedCategory.Id;
                isTableSearch = true;
            }

            if (vm.datePicker.date.startDate) {
                params.StartDate = vm.datePicker.date.startDate.format('YYYY-MM-DD');
                params.EndDate = vm.datePicker.date.endDate.format('YYYY-MM-DD');
                isTableSearch = true;
            }

            if (vm.searchText) {
                params.SearchField = 'Title';
                params.SearchQuery = vm.searchText;
                isTableSearch = true;
            }

            return params;
        }

        function getCategories() {
            HelperService.startLoading('.university-holder');

            UniversityService
                .getCategories()
                .then(success => {
                    vm.categories = success;

                    let currentCategory = vm.categories.find(x => (x.Url == $stateParams.universityCategory));

                    if (currentCategory)
                        vm.selectedCategory = currentCategory;

                    vm.getPaginatedVideo({
                        page: vm.currentPage
                    });

                    HelperService.stopLoading('.university-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function initVars() {
            videosPerPage = 6;
            videosSkip = 0;
            forcePaginationReset = false;
            isTableSearch = false;

            vm.currentPage = 1;
            vm.numberOfPages = 0;

            if (isNaN($stateParams.universityPage)) {
                $state.go('app-master.default.university', {
                    universityPage: 1
                });
            } else
                vm.currentPage = $stateParams.universityPage;

            vm.videos = [];
            vm.isLoading = false;

            vm.datePicker = {
                date: {
                    startDate: moment(),
                    endDate: moment().add(1, 'days')
                },
                options: {
                    'opens': 'left',
                    'timePicker': false,
                    'format': 'DD/MM/YYYY',
                    'ranges': {
                        'Amanhã': [
                            moment().add(1, 'days'),
                            moment().add(1, 'days')
                        ],
                        'Hoje': [
                            moment(),
                            moment()
                        ],
                        'Ontem': [
                            moment().subtract(1, 'days'),
                            moment().subtract(1, 'days')
                        ],
                        '7 Dias': [
                            moment().subtract(7, 'days'),
                            moment()
                        ]
                    },
                    'eventHandlers': {
                        'cancel.daterangepicker': (ev, picker) => {
                            vm.datePicker.date = {
                                startDate: moment(),
                                endDate: moment().add(1, 'days')
                            };
                        }
                    }
                }
            }
        }

        function init() {
            initVars();

            getCategories();
        }
    }
}());